import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { getLocationsByLanguage } from './locations'

export function useLocations() {
  const { locale } = useI18n()

  // Get locations based on current language
  const locations = computed(() => {
    return getLocationsByLanguage(locale.value)
  })

  // Search locations by query
  const searchLocations = (query: string) => {
    if (!query || query.length < 2) return []
    
    const searchTerm = query.toLowerCase()
    return locations.value.filter(location => {
      return (
        location.city.toLowerCase().includes(searchTerm) ||
        location.address.toLowerCase().includes(searchTerm) ||
        location.code.toLowerCase().includes(searchTerm) ||
        location.country.toLowerCase().includes(searchTerm) ||
        (location.destination_translations && 
         location.destination_translations.toLowerCase().includes(searchTerm))
      )
    })
  }

  // Get location by code
  const getLocationByCode = (code: string) => {
    return locations.value.find(location => location.code === code)
  }

  // Get locations by country
  const getLocationsByCountry = (country: string) => {
    return locations.value.filter(location => 
      location.country.toLowerCase().includes(country.toLowerCase())
    )
  }

  return {
    locations,
    searchLocations,
    getLocationByCode,
    getLocationsByCountry
  }
}
